export default "__VITE_ASSET__CpMXpXFs__"